import { Bets, IClientBet } from '../types';
import { BetsMatrixType } from '../BetsArea/types';

export const BetsTypes = {
  ...Bets,
  zero: '0',
  first: '1-18',
  last: '19-36',
  firstDozen: '1st 12',
  secondDozen: '2nd 12',
  lastDozen: '3rd 12',
  firstColumn: '1st COL',
  secondColumn: '2nd COL',
  lastColumn: '3rd COL',
  neighbours: 'neighbours',
  tier: 'tier',
  orphelins: 'orphelins',
  voisins: 'voisins',
  jeuZero: 'zero',
  raceTrackStraight: 'raceTrackStraight',
  hotColdStraight: 'hotColdStraight',
  historyStraight: 'historyStraight',
};

export const numberOnTheRacetrack = [
  '0',
  '26',
  '3',
  '35',
  '12',
  '28',
  '7',
  '29',
  '18',
  '22',
  '9',
  '31',
  '14',
  '20',
  '1',
  '33',
  '16',
  '24',
  '5',
  '10',
  '23',
  '8',
  '30',
  '11',
  '36',
  '13',
  '27',
  '6',
  '34',
  '17',
  '25',
  '2',
  '21',
  '4',
  '19',
  '15',
  '32',
];

export const racetrackSets = {
  leftSet: new Set(['5', '10', '23', '8', '30']),
  bottomSet: new Set(['11', '36', '13', '27', '6', '34', '17', '25', '2', '21', '4', '19', '15']),
  rightSet: new Set(['32', '0', '26', '3', '35']),
  topSet: new Set([
    '12',
    '28',
    '7',
    '29',
    '18',
    '22',
    '9',
    '31',
    '14',
    '20',
    '1',
    '33',
    '16',
    '24',
  ]),
  [BetsTypes.jeuZero]: new Set(['0', '3', '12', '15', '26', '32', '35']),
  [BetsTypes.voisins]: new Set([
    '0',
    '2',
    '3',
    '4',
    '7',
    '12',
    '15',
    '18',
    '19',
    '21',
    '22',
    '25',
    '26',
    '28',
    '29',
    '32',
    '35',
  ]),
  [BetsTypes.tier]: new Set(['5', '8', '10', '11', '13', '16', '23', '24', '27', '30', '33', '36']),
  [BetsTypes.orphelins]: new Set(['1', '6', '9', '14', '17', '20', '31', '34']),
};

export const numberOnTheRacetrackValueIndex = numberOnTheRacetrack.reduce(
  (acc, item, idx) => ({ ...acc, [item]: idx }),
  {},
);

export const areaData: BetsMatrixType = [
  ['3', '6', '9', '12', '15', '18', '21', '24', '27', '30', '33', '36'],
  ['2', '5', '8', '11', '14', '17', '20', '23', '26', '29', '32', '35'],
  ['1', '4', '7', '10', '13', '16', '19', '22', '25', '28', '31', '34'],
];

export const areaDataValueIndex = areaData.reduce(
  (acc, items: string[], index1) => ({
    ...acc,
    ...items.reduce(
      (innerAcc, item, index2) => ({
        ...innerAcc,
        [String(item)]: [Number(index1), Number(index2)],
      }),
      {},
    ),
  }),
  {},
);

export const actionsLayer: IClientBet[][] = [
  [
    { type: Bets.split, selector: ['0', '3'] },
    { type: Bets.straight, selector: ['3'] },
    { type: Bets.split, selector: ['3', '6'] },
    { type: Bets.straight, selector: ['6'] },
    { type: Bets.split, selector: ['6', '9'] },
    { type: Bets.straight, selector: ['9'] },
    { type: Bets.split, selector: ['9', '12'] },
    { type: Bets.straight, selector: ['12'] },
    { type: Bets.split, selector: ['12', '15'] },
    { type: Bets.straight, selector: ['15'] },
    { type: Bets.split, selector: ['15', '18'] },
    { type: Bets.straight, selector: ['18'] },
    { type: Bets.split, selector: ['18', '21'] },
    { type: Bets.straight, selector: ['21'] },
    { type: Bets.split, selector: ['21', '24'] },
    { type: Bets.straight, selector: ['24'] },
    { type: Bets.split, selector: ['24', '27'] },
    { type: Bets.straight, selector: ['27'] },
    { type: Bets.split, selector: ['27', '30'] },
    { type: Bets.straight, selector: ['30'] },
    { type: Bets.split, selector: ['30', '33'] },
    { type: Bets.straight, selector: ['33'] },
    { type: Bets.split, selector: ['33', '36'] },
    { type: Bets.straight, selector: ['36'] },
  ],
  [
    { type: Bets.street, selector: ['0', '2', '3'] },
    { type: Bets.split, selector: ['2', '3'] },
    { type: Bets.corner, selector: ['2', '3', '5', '6'] },
    { type: Bets.split, selector: ['5', '6'] },
    { type: Bets.corner, selector: ['5', '6', '8', '9'] },
    { type: Bets.split, selector: ['8', '9'] },
    { type: Bets.corner, selector: ['8', '9', '11', '12'] },
    { type: Bets.split, selector: ['11', '12'] },
    { type: Bets.corner, selector: ['11', '12', '14', '15'] },
    { type: Bets.split, selector: ['14', '15'] },
    { type: Bets.corner, selector: ['14', '15', '17', '18'] },
    { type: Bets.split, selector: ['17', '18'] },
    { type: Bets.corner, selector: ['17', '18', '20', '21'] },
    { type: Bets.split, selector: ['20', '21'] },
    { type: Bets.corner, selector: ['20', '21', '23', '24'] },
    { type: Bets.split, selector: ['23', '24'] },
    { type: Bets.corner, selector: ['23', '24', '26', '27'] },
    { type: Bets.split, selector: ['26', '27'] },
    { type: Bets.corner, selector: ['26', '27', '29', '30'] },
    { type: Bets.split, selector: ['29', '30'] },
    { type: Bets.corner, selector: ['29', '30', '32', '33'] },
    { type: Bets.split, selector: ['32', '33'] },
    { type: Bets.corner, selector: ['32', '33', '35', '36'] },
    { type: Bets.split, selector: ['35', '36'] },
  ],
  [
    { type: Bets.split, selector: ['0', '2'] },
    { type: Bets.straight, selector: ['2'] },
    { type: Bets.split, selector: ['2', '5'] },
    { type: Bets.straight, selector: ['5'] },
    { type: Bets.split, selector: ['5', '8'] },
    { type: Bets.straight, selector: ['8'] },
    { type: Bets.split, selector: ['8', '11'] },
    { type: Bets.straight, selector: ['11'] },
    { type: Bets.split, selector: ['11', '14'] },
    { type: Bets.straight, selector: ['14'] },
    { type: Bets.split, selector: ['14', '17'] },
    { type: Bets.straight, selector: ['17'] },
    { type: Bets.split, selector: ['17', '20'] },
    { type: Bets.straight, selector: ['20'] },
    { type: Bets.split, selector: ['20', '23'] },
    { type: Bets.straight, selector: ['23'] },
    { type: Bets.split, selector: ['23', '26'] },
    { type: Bets.straight, selector: ['26'] },
    { type: Bets.split, selector: ['26', '29'] },
    { type: Bets.straight, selector: ['29'] },
    { type: Bets.split, selector: ['29', '32'] },
    { type: Bets.straight, selector: ['32'] },
    { type: Bets.split, selector: ['32', '35'] },
    { type: Bets.straight, selector: ['35'] },
  ],
  [
    { type: Bets.street, selector: ['0', '1', '2'] },
    { type: Bets.split, selector: ['1', '2'] },
    { type: Bets.corner, selector: ['1', '2', '4', '5'] },
    { type: Bets.split, selector: ['4', '5'] },
    { type: Bets.corner, selector: ['4', '5', '7', '8'] },
    { type: Bets.split, selector: ['7', '8'] },
    { type: Bets.corner, selector: ['7', '8', '10', '11'] },
    { type: Bets.split, selector: ['10', '11'] },
    { type: Bets.corner, selector: ['10', '11', '13', '14'] },
    { type: Bets.split, selector: ['13', '14'] },
    { type: Bets.corner, selector: ['13', '14', '16', '17'] },
    { type: Bets.split, selector: ['16', '17'] },
    { type: Bets.corner, selector: ['16', '17', '19', '20'] },
    { type: Bets.split, selector: ['19', '20'] },
    { type: Bets.corner, selector: ['19', '20', '22', '23'] },
    { type: Bets.split, selector: ['22', '23'] },
    { type: Bets.corner, selector: ['22', '23', '25', '26'] },
    { type: Bets.split, selector: ['25', '26'] },
    { type: Bets.corner, selector: ['25', '26', '28', '29'] },
    { type: Bets.split, selector: ['28', '29'] },
    { type: Bets.corner, selector: ['28', '29', '31', '32'] },
    { type: Bets.split, selector: ['31', '32'] },
    { type: Bets.corner, selector: ['31', '32', '34', '35'] },
    { type: Bets.split, selector: ['34', '35'] },
  ],
  [
    { type: Bets.split, selector: ['0', '1'] },
    { type: Bets.straight, selector: ['1'] },
    { type: Bets.split, selector: ['1', '4'] },
    { type: Bets.straight, selector: ['4'] },
    { type: Bets.split, selector: ['4', '7'] },
    { type: Bets.straight, selector: ['7'] },
    { type: Bets.split, selector: ['7', '10'] },
    { type: Bets.straight, selector: ['10'] },
    { type: Bets.split, selector: ['10', '13'] },
    { type: Bets.straight, selector: ['13'] },
    { type: Bets.split, selector: ['13', '16'] },
    { type: Bets.straight, selector: ['16'] },
    { type: Bets.split, selector: ['16', '19'] },
    { type: Bets.straight, selector: ['19'] },
    { type: Bets.split, selector: ['19', '22'] },
    { type: Bets.straight, selector: ['22'] },
    { type: Bets.split, selector: ['22', '25'] },
    { type: Bets.straight, selector: ['25'] },
    { type: Bets.split, selector: ['25', '28'] },
    { type: Bets.straight, selector: ['28'] },
    { type: Bets.split, selector: ['28', '31'] },
    { type: Bets.straight, selector: ['31'] },
    { type: Bets.split, selector: ['31', '34'] },
    { type: Bets.straight, selector: ['34'] },
  ],
  [
    { type: Bets.corner, selector: ['0', '1', '2', '3'] },
    { type: Bets.street, selector: ['1', '2', '3'] },
    { type: Bets.line, selector: ['1', '2', '3', '4', '5', '6'] },
    { type: Bets.street, selector: ['4', '5', '6'] },
    { type: Bets.line, selector: ['4', '5', '6', '7', '8', '9'] },
    { type: Bets.street, selector: ['7', '8', '9'] },
    {
      type: Bets.line,
      selector: ['7', '8', '9', '10', '11', '12'],
      label: '',
    },
    { type: Bets.street, selector: ['10', '11', '12'] },
    {
      type: Bets.line,
      selector: ['10', '11', '12', '13', '14', '15'],
      label: '',
    },
    { type: Bets.street, selector: ['13', '14', '15'] },
    {
      type: Bets.line,
      selector: ['13', '14', '15', '16', '17', '18'],
      label: '',
    },
    { type: Bets.street, selector: ['16', '17', '18'] },
    {
      type: Bets.line,
      selector: ['16', '17', '18', '19', '20', '21'],
      label: '',
    },
    { type: Bets.street, selector: ['19', '20', '21'] },
    {
      type: Bets.line,
      selector: ['19', '20', '21', '22', '23', '24'],
      label: '',
    },
    { type: Bets.street, selector: ['22', '23', '24'] },
    {
      type: Bets.line,
      selector: ['22', '23', '24', '25', '26', '27'],
      label: '',
    },
    { type: Bets.street, selector: ['25', '26', '27'] },
    {
      type: Bets.line,
      selector: ['25', '26', '27', '28', '29', '30'],
      label: '',
    },
    { type: Bets.street, selector: ['28', '29', '30'] },
    {
      type: Bets.line,
      selector: ['28', '29', '30', '31', '32', '33'],
      label: '',
    },
    { type: Bets.street, selector: ['31', '32', '33'] },
    {
      type: Bets.line,
      selector: ['31', '32', '33', '34', '35', '36'],
      label: '',
    },
    { type: Bets.street, selector: ['34', '35', '36'] },
  ],
];

export const columnBets: IClientBet[] = [
  {
    type: Bets.column,
    selector: ['3', '6', '9', '12', '15', '18', '21', '24', '27', '30', '33', '36'],
    label: BetsTypes.firstColumn,
  },
  {
    type: Bets.column,
    selector: ['2', '5', '8', '11', '14', '17', '20', '23', '26', '29', '32', '35'],
    label: BetsTypes.secondColumn,
  },
  {
    type: Bets.column,
    selector: ['1', '4', '7', '10', '13', '16', '19', '22', '25', '28', '31', '34'],
    label: BetsTypes.lastColumn,
  },
];

export const zeroBet: IClientBet = {
  type: Bets.straight,
  selector: ['0'],
  label: BetsTypes.zero,
};

export const chancesBets: IClientBet[] = [
  {
    type: Bets.low,
    selector: [
      '1',
      '2',
      '3',
      '4',
      '5',
      '6',
      '7',
      '8',
      '9',
      '10',
      '11',
      '12',
      '13',
      '14',
      '15',
      '16',
      '17',
      '18',
    ],
    label: BetsTypes.first,
  },
  {
    type: Bets.even,
    selector: [
      '2',
      '4',
      '6',
      '8',
      '10',
      '12',
      '14',
      '16',
      '18',
      '20',
      '22',
      '24',
      '26',
      '28',
      '30',
      '32',
      '34',
      '36',
    ],
    label: BetsTypes.even,
  },
  {
    type: Bets.red,
    selector: [
      '1',
      '3',
      '5',
      '7',
      '9',
      '12',
      '14',
      '16',
      '18',
      '19',
      '21',
      '23',
      '25',
      '27',
      '30',
      '32',
      '34',
      '36',
    ],
    label: BetsTypes.red,
  },
  {
    type: Bets.black,
    selector: [
      '2',
      '4',
      '6',
      '8',
      '10',
      '11',
      '13',
      '15',
      '17',
      '20',
      '22',
      '24',
      '26',
      '28',
      '29',
      '31',
      '33',
      '35',
    ],
    label: BetsTypes.black,
  },
  {
    type: Bets.odd,
    selector: [
      '1',
      '3',
      '5',
      '7',
      '9',
      '11',
      '13',
      '15',
      '17',
      '19',
      '21',
      '23',
      '25',
      '27',
      '29',
      '31',
      '33',
      '35',
    ],
    label: BetsTypes.odd,
  },
  {
    type: Bets.high,
    selector: [
      '19',
      '20',
      '21',
      '22',
      '23',
      '24',
      '25',
      '26',
      '27',
      '28',
      '29',
      '30',
      '31',
      '32',
      '33',
      '34',
      '35',
      '36',
    ],
    label: '',
  },
];

export const dozenBets: IClientBet[] = [
  {
    type: Bets.dozen,
    selector: ['1', '2', '3', '4', '5', '6', '7', '8', '9', '10', '11', '12'],
    label: BetsTypes.firstDozen,
  },
  {
    type: Bets.dozen,
    selector: ['13', '14', '15', '16', '17', '18', '19', '20', '21', '22', '23', '24'],
    label: BetsTypes.secondDozen,
  },
  {
    type: Bets.dozen,
    selector: ['25', '26', '27', '28', '29', '30', '31', '32', '33', '34', '35', '36'],
    label: BetsTypes.lastDozen,
  },
];
